module.exports = __webpack_public_path__ + "static/media/Hypno_gaussian2.4c8e2afb.png";